// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazy, type LazyComponent } from 'react-loosely-lazy';
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ConversationConfig } from '../modal/types';

// Temporary solution to integrate with the Universal Create button
// Since there is no entrypoint support in UC right now
export const LazyLoadedSmartCreationModal: LazyComponent<
	({
		cloudId,
		accountId,
		orgId,
		onClose,
	}: ConversationConfig & {
		onClose: () => void;
	}) => React.JSX.Element
> = lazy(() =>
	import(/* webpackChunkName: "async-jira-smart-creation" */ '../modal/index').then(
		(module) => module.SmartCreationModalInner,
	),
);

type JiraSmartCreationEntrypointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	ConversationConfig & {
		onClose: () => void;
	},
	Record<string, never>
>;

export const jiraSmartCreationEntrypoint: EntryPoint<JiraSmartCreationEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<JiraSmartCreationEntrypointComponent>(
			/* webpackChunkName: "async-jira-smart-creation" */ '../modal/index',
			{
				moduleId: 'async-jira-smart-creation',
			},
		),
		getPreloadProps: () => ({}),
	});
